import { render, staticRenderFns } from "./RecordMessage.vue?vue&type=template&id=c8c9c0c2&scoped=true&"
import script from "./RecordMessage.vue?vue&type=script&lang=js&"
export * from "./RecordMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c9c0c2",
  null
  
)

export default component.exports